module.exports = __webpack_public_path__ + "static/media/rsvp.ac436c0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/rsvp.svg
// module id = 973
// module chunks = 70